import { Factory } from '../services/Factory';
import { IConfigService } from '../services/config';
import { TokenService } from '../services/authentication/TokenService';
import { StateService } from '../services/state/StateService';
import { AccountService } from '../services/account/AccountService';
import { ProjectService } from '../services/project/ProjectService';
import { INotificationService } from '../services/notification';
import { IRootScope } from '../IRootScope';
import { takeDeepLinkRoute } from '../../src/services/deepLink';

export class HomeController {
  constructor(scope, rootScope: IRootScope, http, uibModal, location: angular.ILocationService, configService: IConfigService, tokenService: TokenService, stateService: StateService, accountService: AccountService, projectService: ProjectService, notificationService: INotificationService, navigationService, browserService) {
      // B2C fragment: `id_token=...`, plus `state=...` on AccessID deep links.
      let token = new URLSearchParams(location.hash()).get("id_token");
      if (token) {

        tokenService.Fetch(null, null, null, token).then(function (response) {
          notificationService.dismissAll();

          accountService.Fetch()
            .success((data) => {
              notificationService.addInfo({
                title: "Welcome back " + accountService.GetFirstName(),
                timeout: 5000
              });
            }).error(data => {
            console.log(data)
          });

          stateService.SetLoggedIn();

          // replace() keeps the id_token out of browser history.
          const deepLink = takeDeepLinkRoute();
          location.hash("");
          if (deepLink) {
            location.path(deepLink.path).search(deepLink.search).replace();
          } else {
            location.path("/project").replace();
          }
        })

        scope.token = token;
      }

      navigationService.clearActiveTab();
      rootScope.$broadcast("clearCurrentSelected");

      scope.saving = false;
      scope.signUpSuccess = false;

      scope.saveAccount = (account: any) => {
        scope.saving = true;

        let data: any = _.pick(account, "email", "firstName", "lastName", "phone");
        data.frontendUrl = configService.getFrontendUrl();

        http.post(configService.getServerBaseUrl() + "/account/register", data).success(function (data, status) {
          scope.saving = false;
          scope.signUpSuccess = true;

          // Here we"re telling the user that he needs to verify email
        }).error(function (data, status) {
          scope.saving = false;
          _.each(data.errors, function (error) {
            scope.SignUpForm[error.field].$setValidity(error.code, false);
          });
        });
      };

      if (!browserService.isSupportedBrowser()) {
        uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/dialog_outdated_browser.html",
          controller: "BrowserModalCtrl",
          resolve: {
            title: function () {
              return "Outdated Browser"
            },
            message: function () {
              return "You are using an outdated browser."
            },
            href: function () {
              return "http://browsehappy.com/"
            },
            hrefTitle: function () {
              return "Upgrade your browser today"
            }
          }
        });
      }
    }
  }

frontendApp.controller("HomeController", ["$scope", "$rootScope", "$http", "$uibModal", "$location", "ConfigService", "TokenService", "StateService", "AccountService", "ProjectService", "NotificationService", "NavigationService", "BrowserService", Factory.Create(HomeController)]);


